<page-content>
    <header-elitment header>
    </header-elitment>
    <side-menu left-menu>
    </side-menu>
    <ng-container *ngIf="!is401">
        <module-content [title]="'Users_list'"
                        [mainActions]="isLoading ? [] : shortcutMenus"
                        [isLoading]="isLoading">
            <div *ngIf="dataSource.count === 0" class="legend">{{ 'No_user_yet' | translate }}</div>
            <mat-form-field *ngIf="dataSource.count > 0"
                            color="primary"
                            class="search-bar">
                <input matInput
                       type="text"
                       maxlength="255"
                       placeholder="{{ 'Filter' | translate }}"
                       #filterInput
                       (keyup)="onFilterKeyup(filterInput.value)">
                <mat-icon matSuffix>search</mat-icon>
            </mat-form-field>
            <mat-table *ngIf="dataSource.count > 0"
                       [dataSource]="dataSource"
                       matSort
                       (matSortChange)="onSortChange($event)">
                <mat-header-row *matHeaderRowDef="columns"></mat-header-row>
                <mat-row *matRowDef="let row; columns: columns;"></mat-row>
                <ng-container matColumnDef="image">
                    <mat-header-cell *matHeaderCellDef class="image-cell hideable-500"></mat-header-cell>
                    <mat-cell *matCellDef="let row" class="image-cell hideable-500">
                        <img *ngIf="row.user.avatar"
                             [src]="conf.storageRootUrl + row.user.avatar"  alt="avatar"/>
                        <mat-icon *ngIf="!row.user.avatar">
                            person
                        </mat-icon>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="name">
                    <mat-header-cell *matHeaderCellDef mat-sort-header class="name-cell">{{ 'User' | translate }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="name-cell">
                        <div>{{ row.user.firstName + ' ' + row.user.lastName }}</div>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="roles">
                    <mat-header-cell *matHeaderCellDef class="roles-cell">{{ 'Roles' | translate }}</mat-header-cell>
                    <mat-cell *matCellDef="let row" class="roles-cell">
                        <mat-form-field class="no-underline no-padding">
                            <mat-select [placeholder]="row.rolesIds.length ? '' : 'No_role_selected' | translate"
                                        [multiple]="true"
                                        [disabled]="!organizationRights.UPDATE_USER_ROLES || isLoading"
                                        (selectionChange)="onUserRolesChanged(row)"
                                        (openedChange)="onUserRolesToggled($event)"
                                        [(ngModel)]="row.rolesIds">
                                <mat-option *ngFor="let role of availableRoles"
                                            [value]="role.id"
                                            [disabled]="currentUser.user?.id === row.user.id">
                                    <!-- on peut pas s'enlever le rôle d'admin -->
                                    {{ role.name }}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </mat-cell>
                </ng-container>
                <ng-container matColumnDef="actions">
                    <mat-header-cell *matHeaderCellDef class="actions-cell">
                    </mat-header-cell>
                    <mat-cell *matCellDef="let row" class="actions-cell">
                        <button mat-icon-button
                                [matMenuTriggerFor]="rowMoreMenu"
                                [disabled]="isLoading">
                            <mat-icon>more_vert</mat-icon>
                        </button>
                        <mat-menu #rowMoreMenu="matMenu" xPosition="before">
                            <button mat-menu-item
                                    [disabled]="currentUser.user?.id === row.user.id"
                                    (click)="onRemoveUserClicked(row)">
                                <!-- on peut pas se retirer de l'organization -->
                                {{ 'Remove' | translate }}
                            </button>
                        </mat-menu>
                    </mat-cell>
                </ng-container>
            </mat-table>
            <mat-paginator [class.hidden]="dataSource.count == 0"
                           [pageSizeOptions]="[10]"
                           hidePageSize
                           showFirstLastButtons>
            </mat-paginator>
        </module-content>
    </ng-container>
    <error-401 *ngIf="is401"></error-401>
    <footer-elitment footer></footer-elitment>
</page-content>
